<template>
  <v-dialog v-model="dialogDelete" max-width="500px" persistent>
    <v-card class="rounded-lg">
      <v-card-title class="pa-0">
        <v-toolbar :color="$colors[0]" class="text-white rounded-t-lg" dark elevation="0">
          <v-icon left>mdi-alert-circle</v-icon>
          <span class="text-h6 font-weight-medium">Confirmation de suppression</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeDelete">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="mt-8 py-5 d-flex flex-column align-center">
        <v-avatar color="red lighten-4" size="80" class="mb-4">
          <v-icon size="40" color="red">mdi-delete-alert</v-icon>
        </v-avatar>
        <span class="text-subtitle-1 font-weight-medium text-center">
          Êtes-vous sûr de vouloir supprimer ce fournisseur ?
        </span>
        <span class="text-body-2 grey--text text-center mt-2">
          Cette action est irréversible.
        </span>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" outlined rounded class="px-6" @click="closeDelete">
          <v-icon left>mdi-cancel</v-icon> Annuler
        </v-btn>
        <v-btn color="red darken-1" rounded dark class="px-6" @click="deleteItemConfirm">
          <v-icon left>mdi-delete</v-icon> Supprimer
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";
export default {
  props: {
    dialogDeleteProps: Boolean,
    editedItemProps: Object,
    editedIndexProps: Number,
  },
  data() {
    return {
      dialogDelete: false,
      editedItem: null,
      editedIndex: 0,
    };
  },
  watch: {
    dialogDeleteProps: function (newValue) {
      this.dialogDelete = newValue;
    },
    editedItemProps: {
      handler(newValue) {
        this.editedItem = newValue;
      },
      deep: true,
    },
    editedIndexProps: function (newValue) {
      this.editedIndex = newValue;
    },
  },
  methods: {
    closeDelete() {
      this.dialogDelete = false;
      this.$emit("closeDialog", this.dialog);
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async deleteItemConfirm() {
      await axios({
        url: process.env.VUE_APP_URL_API_ADMIN + "deleteAssureurDatatable/",
        method: "POST",
        data: {
          deleteAssureur: this.editedItem,
          token: this.getToken("dash_token"),
        },
      }).then((res) => {
        this.$emit("deleteItem", this.editedIndex);
        // this.listDataAssureur.splice(this.editedIndex, 1);
      });
      this.closeDelete();
    },
  },
};
</script>
